// TODO: rename to "TableAction" and couple to Tables
import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';

import { Button } from '@redshelf/redshelf-ui';

import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      '& + &': {
        marginLeft: theme.spacing(1),
      },
    },
  };
});

const Action = ({ children, ...props }) => {
  const classes = useStyles();

  return (
    <Button routerLink={!isNil(props.to)} className={classes.root} {...props}>
      {children}
    </Button>
  );
};

Action.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   *
   * if this exits, render this component as a `ButtonRouterLink`. If this doesn't exist, render this component as a `Button`
   *
   * `string`: A string representation of the Link location, created by concatenating the location’s pathname, search, and hash properties. <a href="https://reactrouter.com/web/api/Redirect/to-string" target="_blank">Learn More</a>
   *
   * `object`: An object that can have any of the following properties: `pathname`, `search`, `hash`, `state`. <a href="https://reactrouter.com/web/api/Redirect/to-object" target="_blank">Learn More</a>
   *
   * `function`: A function to which current location is passed as an argument and which should return location representation as a string or as an object. <a href="https://reactrouter.com/web/api/Redirect/to-function" target="_blank">Learn More</a>
   */
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
};

Action.defaultProps = {};

export default Action;
